import type { IPoiTranslation } from '@/shared/api/types/poi-types'

export function createEmptyPoiTranslation(language: string): IPoiTranslation {
  return { language, name: '', description: '', audioContent: '', hasAudio: false }
}

/** Trims the text fields so whitespace-only differences never count as an edit or reach the API. */
export function normalizePoiTranslations(translations: IPoiTranslation[]): IPoiTranslation[] {
  return translations.map((item) => ({
    ...item,
    name: item.name.trim(),
    description: item.description.trim(),
    audioContent: item.audioContent.trim(),
  }))
}

/** In create mode: has the user typed anything or generated audio in any language? (decides "unsaved changes") */
export function hasPoiTranslationContent(translations: IPoiTranslation[]): boolean {
  return translations.some(
    (item) =>
      item.name.trim().length > 0 ||
      item.description.trim().length > 0 ||
      item.hasAudio === true ||
      Boolean(item.audioUrl),
  )
}
